import { render, staticRenderFns } from "./TabelaContratosComAditivos.vue?vue&type=template&id=c9dec738&"
import script from "./TabelaContratosComAditivos.vue?vue&type=script&lang=js&"
export * from "./TabelaContratosComAditivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports